module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 91.c43f4df4.png";